import { _ } from "./i18n";
import Decimal from "decimal.js";


// *************************************************************************
// Select product variant
// *************************************************************************

function isObjectsEqual(object1, object2) {
	var keys1 = Object.keys(object1);
	var keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (var key in object1) {
		if (object1[key] != object2[key]) {
			return false;
		}
	}

	return true;
}

function cantainsObject(obj, arr) {
	for (var i = 0; i < arr.length; ++i) {
		if (isObjectsEqual(obj, arr[i])) {
			return true;
		}
	}
	return false;
}


document.addEventSelectorListener("input", "[data-select-product]", function(event, target) {
	var attributes = {};
	var elements = document.querySelectorAll("[data-select-product]");
	for (var i = 0; i < elements.length; ++i) {
		var element = elements[i];
		var isSelected = (element.tagName.match(/input/i) && element.getAttribute("type").match(/radio/i) && element.checked) || element.tagName.match(/select/i)
		if (isSelected) {
			attributes[element.getAttribute("data-select-product")] = element.value;
		}
	}

	var selects = document.querySelectorAll("[data-select-product-values]");
	for (var i = 0; i < selects.length; ++i) {
		var select = selects[i];
		var selectAttributes = JSON.parse(select.getAttribute("data-select-product-values"));
		var selectedValue = select.value;
		select.innerHTML = "<option value=''>Vyberte...</option>";

		for (var j = 0; j < selectAttributes.length; ++j) {
			var selectAttribute = selectAttributes[j];

			if (cantainsObject(attributes, selectAttribute.attrs)) {
				var option = document.createElement("option");
				option.setAttribute("value", selectAttribute.title);
				option.innerText = selectAttribute.title;
				if (selectedValue == selectAttribute.title) {
					option.selected = true;
				}
				select.appendChild(option);
			}

		}

	}
});


// *************************************************************************
// Compute prices
// *************************************************************************

function updatePrices() {
	var form = document.querySelector("#product-select-form");
	var productId = form.elements["product_variant[product_id]"].value;
	var caloriesTitle = form.elements["product_variant[calories_title]"].value;

	var pricesElement = document.querySelector("[data-prices]");
	var prices = JSON.parse(pricesElement.getAttribute("data-prices"));

	var sum = new Decimal("0.0");
	var priceElements = document.querySelectorAll("[data-price]");
	for (var i = 0; i < priceElements.length; ++i) {
		var priceElement = priceElements[i];
		if (priceElement.checked || priceElement.selected) {
			sum = sum.plus(priceElement.getAttribute("data-price"));
		}
	}

	if (productId && caloriesTitle && prices[productId][caloriesTitle]) {
		sum = sum.plus(prices[productId][caloriesTitle]);
	}
	else {
		sum = "&mdash;"
	}

	console.log(sum);

	pricesElement.innerHTML = sum.toString().replace(".", ",") + " " + _("Kč / den");
}

document.addEventSelectorListener("click input", "#product-select-form input, #product-select-form select", function(event, target) {
	updatePrices();
});
